export default "__VITE_ASSET__CyIjBayY__"